module.exports = __webpack_public_path__ + "static/media/lang5.592d64ec.mp3";